export class WaitTime {
    time: string;
}
